import { createAction, createReducer } from 'redux-act';

import { SravniNewsSharedModelsLikesUserLikesResult, UserSelfLikesListParams } from '../__generated__/news/Api';
import { getUserLikes } from '../services/likes';
import { App } from '../types';

import { setArticleUserLikes } from './likes';

interface IState {
  data: SravniNewsSharedModelsLikesUserLikesResult;
  isLoading: boolean;
  error: string | null;
}

const initialState: IState = {
  isLoading: false,
  error: null,
  data: {},
};

export const fetchInitialUserLikesStart = createAction('initialUserLikes/fetch/start');
export const fetchInitialUserLikesError = createAction<{ error: string }>('initialUserLikes/fetch/error');
export const setInitialUserLikes = createAction<SravniNewsSharedModelsLikesUserLikesResult>('initialUserLikes/set');

export const fetchUserLikes = (params: UserSelfLikesListParams): App.ReduxAction => {
  return async (dispatch, getState) => {
    const { initialUserLikes } = getState() || {};

    if (Object.values(initialUserLikes.data).length) return;

    try {
      dispatch(fetchInitialUserLikesStart());

      const userLikes = await getUserLikes(params);

      dispatch(setInitialUserLikes(userLikes));
      dispatch(setArticleUserLikes(userLikes.materials));
    } catch (e) {
      const error = e?.message || 'Could not fetch user likes';

      dispatch(fetchInitialUserLikesError({ error }));
    }
  };
};

export default createReducer({}, initialState)
  .on(setInitialUserLikes, (state, data) => {
    return {
      ...state,
      data,
      isLoading: false,
    };
  })
  .on(fetchInitialUserLikesStart, (state) => ({ ...state, isLoading: true }))
  .on(fetchInitialUserLikesError, (state, { error }) => {
    return {
      ...state,
      error,
      isLoading: false,
    };
  });
